<nav class="head-nav">
    <div class="nav-container">
        <div>
            <h2>{{ "restaurant.Events" | translate }}</h2>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
                </li>
                <li class="breadcrumb-item">{{"content4.Events & Guests Announcements" | translate}}</li>
                <li class="breadcrumb-item">{{ "restaurant.Events" | translate }}</li>
            </ol>
        </div>
    </div>
</nav>
<div class="button-group-custom">
    <mat-button-toggle-group [(ngModel)]="filterModel.status" (change)="typeFilter($event)">
        <mat-button-toggle *ngFor="let status of typesListAll" [value]="status.id" [disabled]="dataLoading">
            {{status.name}}
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>

<div class="page">
    <div class="page-filters">
        <div class="sort-item">
            <span class="count-page">
                <span>{{recordsData?.totalCount}}</span>
                <ng-container *ngIf="filterModel.status == 1">
                    {{ 'content4.Active Events' | translate }}
                </ng-container>
                <ng-container *ngIf="filterModel.status == 0">
                    {{ 'content4.Past Events' | translate }}
                </ng-container>
            </span>
        </div>
        <div class="filters-container">
            <div class="create-item">
                <a class="btn-light" mat-stroked-button (click)="openEventForm(null)" *ngIf="recordsData?.canAdd">
                    <img src="./assets/images/icons/plus-ic.svg">
                    <span>{{"availabilty.Add New" | translate}}</span>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>

    <ng-container *ngIf='!dataLoading'>
        <div *ngIf="recordsData?.pageData && recordsData?.pageData?.length; else dataEmpty">

            <div class="table-responsive table-container">
                <table class="table table-primary">
                    <thead>
                        <tr>
                            <th class="font-14 fontRegular">{{'content4.Event Title' | translate}}</th>
                            <th class="font-14 fontRegular" style="width: 25%;">{{'content4.Event Dates' | translate}}</th>
                            <th class="font-14 fontRegular">{{'content4.Event Time' | translate}}</th>
                            <th class="font-14 fontRegular">{{'restaurant.Branches' | translate}}</th>
                            <th class="font-14 fontRegular">{{'restaurant.No.OfReservation' | translate}}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of recordsData?.pageData">
                            <td>
                                <div class="name-with-image">
                                    <div class="image-circle">
                                        <span *ngIf="!item.icon">{{ item.title | shortName }}</span>
                                        <img *ngIf="item.icon" [src]="item.icon" (error)="item.icon = ''">
                                    </div>
                                    <div class="name">
                                        <h5 [matTooltip]="item.title" class="font-14 fontRegular">{{item.title}}</h5>
                                    </div>
                                </div>
                            </td>
                            <td class="font-14 fontRegular">
                              {{item.start | date:'d MMMM, y'}}
                              <span *ngIf="item.end" class="grey-color font-14 ml-2 mr-2">{{ 'content2.to' | translate }}</span>
                              <span *ngIf="item.end">{{item.end | date:'d MMMM, y'}}</span>
                            </td>
                            <td class="font-14 fontRegular">{{item.timeStart}} <span *ngIf="item.timeEnd"
                                    class="grey-color font-14 ml-2 mr-2"> {{ 'content2.to' | translate }}</span> {{item.timeEnd}}
                            </td>
                            <td class="font-14 fontRegular"><span
                                    *ngFor="let branch of item.branches | slice: 0: 3; let i = last">{{
                                    branch.title}} <span *ngIf="!i">/ </span> </span> <span
                                    *ngIf="item.branches.length > 2">/ + {{item.branches.length - 2}}</span>
                            </td>
                            <td class="font-14 fontRegular">{{item.reservationsCount}}</td>
                            <td>
                                <div class="btn-actions">
                                    <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                        (click)="openEventForm(item)" *ngIf="item.canEdit">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button [matTooltip]="'general.Delete' | translate"
                                        (click)="deleteRecord(item.id)" *ngIf="item.canDelete">
                                        <mat-icon class="delete-icon">delete</mat-icon>
                                    </button>

                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>

            <div class="pagination-container" *ngIf="recordsData && (pageCount > 1 || recordsData['totalCount'] > pageSize)">
                <mat-paginator [length]="recordsData['totalCount']" [pageSize]="filterModel.pageSize"
                    [pageSizeOptions]="[5, 10, 20]" (page)="changePagingParams($event)" [pageIndex]="filterModel.pageNumber">
                </mat-paginator>
            </div>

        </div>
        <ng-template #dataEmpty>
            <empty-state [title]='"content4.Events list is empty" | translate'
                [img]="'/assets/images/icons/events-empty.svg'"></empty-state>
        </ng-template>
    </ng-container>
</div>
